import { required, requiredIf } from 'vuelidate/lib/validators';
import { getAutomationTriggerCategory } from 'dashboard/routes/dashboard/settings/automation/constants/events';
import {
  createOpportunityActionErrors,
  opportunityActivityActionErrors,
} from 'dashboard/helper/automationOpportunityActionHelper';

const opportunityStatusHasLossReason = actionParams => {
  const params = Array.isArray(actionParams)
    ? actionParams
    : [actionParams].filter(Boolean);

  const status = params.find(param => param?.__type !== 'loss_reason');
  if (status?.id !== 'lost') return true;

  return params.some(param => param?.__type === 'loss_reason');
};

export default {
  validations: {
    automation: {
      name: {
        required,
      },
      description: {
        required,
      },
      event_name: {
        required,
        belongsToTriggerCategory(value) {
          return (
            !this.triggerCategory ||
            getAutomationTriggerCategory(value) === this.triggerCategory
          );
        },
      },
      conditions: {
        required,
        $each: {
          values: {
            required: requiredIf(prop => {
              return !(
                prop.filter_operator === 'is_present' ||
                prop.filter_operator === 'is_not_present'
              );
            }),
          },
        },
      },
      actions: {
        required,
        $each: {
          action_params: {
            required: requiredIf(prop => {
              return !(
                prop.action_name === 'mute_conversation' ||
                prop.action_name === 'snooze_conversation' ||
                prop.action_name === 'resolve_conversation' ||
                prop.action_name === 'conversation_opened' ||
                prop.action_name === 'unassign_agent' ||
                prop.action_name === 'remove_assigned_team'
              );
            }),
            opportunityStatusHasLossReason: (actionParams, action) => {
              if (action.action_name !== 'change_opportunity_status') {
                return true;
              }
              return opportunityStatusHasLossReason(actionParams);
            },
            opportunityActivityIsComplete: (actionParams, action) => {
              if (action.action_name !== 'create_opportunity_activity') {
                return true;
              }
              return !opportunityActivityActionErrors(actionParams).length;
            },
            createOpportunityIsComplete(actionParams, action) {
              if (action.action_name !== 'create_opportunity') return true;
              return !createOpportunityActionErrors(
                actionParams,
                this.pipelines || []
              ).length;
            },
          },
        },
      },
    },
  },
};
